import {
	getCulture,
	getMarketId,
	getPageId
} from "./globalData";

export function initGlobalAxiosSettings(axiosGlobalOrInstance) {
	axiosGlobalOrInstance.interceptors.request.use((config) => {
		// in mocked axios headers is empty
		if (config.headers) {
			config.headers['App-Language'] = getCulture();
			config.headers['App-Market-Id'] = getMarketId();
			config.headers['App-Page-Id'] = getPageId();
		}

		return config;
	});
}
